import React, { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { TestCaseFlowDataContext } from "../TestcaseGenerationPage";
import { ReactComponent as AutomateIcon } from "../../../images/automateIcon.svg";
import FullscreenToggle from "../../custom-components/FullScreenToggle";
import UserStoryComponent from "../../output-components/testcase-generation/UserStoryComponent";
import UseCasesComponent from "../../output-components/testcase-generation/UseCasesComponent";
import TestCasesComponent from "../../output-components/testcase-generation/TestCasesComponent";
import GenerateFSDComponent from "../../output-components/testcase-generation/GenerateFSDComponent";
import TestConditionsComponent from "../../output-components/testcase-generation/TestConditions";
import TestTechniquesComponent from "../../output-components/testcase-generation/TestTechniques";

const TestCasesOutputPage = () => {
  const location = useLocation();

  const {
    userStory,
    setUserStory,
    functionalSpecDocument,
    setFunctionalSpecDocument,
    useCase,
    setUseCase,
    testcases,
    setTestCases,
    testConditions,
    setTestConditions,
    testTechniques,
    setTestTechniques,
    traceabilityMatrix,
    setTraceabilityMatrix,
  } = useContext(TestCaseFlowDataContext);

  useEffect(() => {
    setUserStory(location.state?.userStory);
    setFunctionalSpecDocument(location.state?.functionalSpecDocument);
    setUseCase(location.state?.useCase);
    setTestCases(location.state?.testcases);
    setTestConditions(location.state?.testConditions);
    setTestTechniques(location.state?.testTechniques);
    setTraceabilityMatrix(location.state?.traceabilityMatrix);
  }, [
    location.state?.userStory || "",
    location.state?.functionalSpecDocument || {},
    location.state?.useCase || {},
    location.state?.testConditions || {},
    location.state?.testTechniques || {},
    location.state?.traceabilityMatrix || [],
    location.state?.testcases || [],
  ]);

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "600px",
        margin: "10px auto",
        "& > *:not(:last-child)": {
          marginBottom: "16px",
        },
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb={0.1}
      >
        <Box display="flex" alignItems="center" mb={0.1}>
          <AutomateIcon style={{ marginRight: 4 }} />
          <Typography
            variant="body2"
            color="text.secondary"
            gutterBottom
            sx={{ mt: 0.5 }}
          >
            Automate and create comprehensive, high-quality test cases
            effortlessly
          </Typography>
        </Box>
        <FullscreenToggle />
      </Box>

      {userStory &&
        typeof userStory === "string" &&
        userStory.trim().length > 0 && (
          <UserStoryComponent userStory={userStory} />
        )}

      {functionalSpecDocument &&
        Object.entries(functionalSpecDocument).length > 0 && (
          <GenerateFSDComponent />
        )}

      {useCase && Object.entries(useCase).length > 0 && <UseCasesComponent />}

      {testConditions && Object.keys(testConditions).length > 0 && (
        <TestConditionsComponent />
      )}

      {testTechniques && Object.keys(testTechniques).length > 0 && (
        <TestTechniquesComponent />
      )}

      {testcases && testcases.length > 0 && (
        <TestCasesComponent
          testCasesData={testcases}
          setTestCasesData={setTestCases}
          traceabilityMatrix={traceabilityMatrix}
        />
      )}

      <Box
        component="footer"
        sx={{
          width: "100%",
          maxWidth: "601px",
          backgroundColor: "#f6f3f2",
          textAlign: "center",
          paddingX: "5px",
          position: "fixed",
          bottom: "0",
          zIndex: "99",
        }}
      >
        <Typography variant="caption" color="textSecondary">
          Use QMentisAI™ with human supervision, as with all generative AI
          tools.
        </Typography>
      </Box>
    </Box>
  );
};

export default TestCasesOutputPage;
